import { useTranslation } from 'react-i18next';
import { Button, PageHeader } from '../../../../../components';
import styles from './style.module.scss';
import { Form, Row, Col, Spin } from 'antd';
import { useLeasingPlans } from '../useLeasingPlans';
import FormSections from './formSections';
import { CheckOutlined } from '@ant-design/icons';
import moment from 'moment';

const Edit = ({ isNew }) => {
  const { t } = useTranslation();
  const {
    form,
    updateInProcess,
    handleCreateOrUpdate,
    assets,
    singleItem,
    loading,
    filterLoading,
  } = useLeasingPlans(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  // const title = isNew ? t('CREARE PLAN') : t('MODIFICA PLAN');
  const title = isNew ? t('Pubblica documento') : t('Modifica documento');
  return (
    <>
      <div>
        <PageHeader title={title} />
        <Spin spinning={updateInProcess || loading || filterLoading}>
          <div className={styles.content}>
            <Row gutter={[0, 40]}>
              <Col span={24}>
                <Form
                  form={form}
                  layout={'vertical'}
                  name='basic'
                  wrapperCol={{
                    span: 24,
                  }}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  initialValues={{
                    title: '',
                    day: moment(),
                    file: null,
                    leasings_asset_id: '',
                  }}
                  onFieldsChange={(changedFields) => {
                    form.setFields([
                      {
                        name: changedFields[0].name[0],
                        errors: [],
                      },
                    ]);
                  }}
                >
                  <FormSections
                    assets={assets}
                    file={
                      singleItem?.id
                        ? {
                          url: singleItem?.file?.file_url,
                          name: `${singleItem?.file?.file_name} file`,
                        }
                        : null
                    }
                  />
                </Form>
              </Col>
              <Col span={24}>
                <Row gutter={16}>
                  <Col>
                    <Button
                      onClick={onClickSave}
                      width={'150px'}
                      big
                      icon={<CheckOutlined />}
                      loading={updateInProcess}
                    >
                      {t('Invia')}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Spin>
      </div>
    </>
  );
};

export default Edit;
